import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// initalize i18n
import './translations/translations';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
